var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBugreport(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    xmlns: "http://www.w3.org/2000/svg",
    desc: "Created with imagetracer.js version 1.2.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(0,0,0)",
    stroke: "rgb(0,0,0)",
    strokeWidth: 1,
    opacity: 0,
    d: "M 0 0 L 57 0.5 Q 44.5 2 35.5 7 Q 22.8 14.3 14 25.5 L 5 41.5 L 1 57.5 L 1 172.5 Q 6 201.5 25.5 216 L 40.5 225 L 59.5 230 L 133.5 230 L 138 225.5 L 138 221.5 L 135.5 218 L 133.5 217 L 61.5 217 L 45.5 213 Q 35.1 208.4 28 200.5 L 19 187.5 L 14 169.5 L 14 59.5 Q 17.7 36.7 32.5 25 L 45.5 17 L 60.5 13 L 125 13 L 125 42.5 Q 128.4 55.6 137.5 63 L 153.5 71 L 183 71 L 183 122.5 L 185 126 Q 187.1 127.6 192.5 127 L 196 123.5 L 196 62.5 L 136.5 2 L 134 0.5 L 256 0 L 256 255.5 L 255.5 256 L 195.5 256 L 195.5 255 L 204.5 253 L 218 241.5 L 221.5 236 L 225.5 237 L 238.5 248 L 241.5 249 L 247 245.5 L 248 240.5 L 237.5 229 L 227 224 L 228 213 L 251.5 213 L 254 210.5 L 255 204.5 L 248.5 200 L 228 200 L 227 193 Q 239.4 188.7 247 178.5 L 248 173.5 L 244.5 169 L 239.5 168 L 234 172.5 Q 234.8 174.8 232.5 174 Q 228.1 179.4 221 181 L 218 174.5 L 219 173.5 L 219 160.5 Q 217.1 150.4 211 144.5 L 225 140 Q 226.6 137.9 226 132.5 L 225 130 L 219.5 128 Q 207.3 130.3 198.5 136 Q 194.2 132.3 184.5 134 L 179.5 136 Q 171.5 130 159.5 128 L 153 132.5 Q 151.8 139.8 156.5 141 L 168 144.5 L 160 160.5 L 160 173.5 L 161 175.5 L 158 181 Q 147.5 177.8 141.5 169 L 136.5 168 L 132 171.5 L 131 175.5 L 139.5 186 L 152 193.5 L 151 200 L 135.5 200 L 130 204.5 Q 128.8 211.8 133.5 213 L 150.5 213 Q 151.5 213 151 217.5 L 152 224 Q 140.2 228 133 237.5 L 131 242.5 L 133.5 247 L 138.5 249 L 144 245.5 L 146.5 242 L 157.5 236 L 167.5 248 L 177.5 254 L 185 255.5 L 0 256 L 0 0 Z M 48 68 L 43 70 L 42 73 Q 41 80 46 81 L 107 81 L 109 80 L 111 75 L 110 72 L 105 68 L 48 68 Z M 48 108 L 43 110 Q 41 112 42 118 L 49 122 L 149 122 L 154 120 L 156 116 L 155 112 L 150 108 L 48 108 Z M 48 148 L 42 153 Q 41 158 43 160 L 49 162 L 150 162 L 153 161 L 156 156 L 155 152 L 150 148 L 48 148 Z "
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 57.5 0 L 63 0.5 L 57.5 1 L 57.5 0 Z "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 132.5 0 L 135 1.5 L 133.5 1 L 132.5 0 Z "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 136.5 2 L 194.5 61 L 136.5 2 Z "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 35.5 7 L 34.5 9 L 35.5 7 Z "
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 30.5 10 L 29.5 12 L 30.5 10 Z "
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 26.5 13 L 23.5 17 L 26.5 13 Z "
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 57.5 13 L 60 13.5 L 57.5 14 L 57.5 13 Z "
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 17.5 22 L 14.5 26 L 17.5 22 Z "
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 35.5 22 L 33.5 25 L 35.5 22 Z "
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 13.5 27 L 12.5 29 L 13.5 27 Z "
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 29.5 27 L 28.5 29 L 29.5 27 Z "
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 11.5 30 L 10.5 32 L 11.5 30 Z "
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 25.5 32 L 23.5 35 L 25.5 32 Z "
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 22.5 36 L 21.5 38 L 22.5 36 Z "
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 125.5 38 L 126 42.5 L 125 42.5 L 125.5 38 Z "
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 3.5 47 L 4 49.5 L 3 49.5 L 3.5 47 Z "
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 2.5 51 L 3 53.5 L 2 53.5 L 2.5 51 Z "
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 14.5 56 L 15 58.5 L 14 58.5 L 14.5 56 Z "
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 1.5 57 L 2 172.5 L 1 172.5 L 1.5 57 Z "
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 132.5 57 L 137.5 63 L 132.5 57 Z "
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 140.5 64 L 141.5 66 L 140.5 64 Z "
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 47.5 68 L 105 68.5 L 47.5 69 L 47.5 68 Z "
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 107.5 69 L 109.5 72 L 107.5 69 Z "
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 153.5 70 L 158 70.5 L 153.5 71 L 153.5 70 Z "
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 183.5 71 L 184 122.5 L 183 122.5 L 183.5 71 Z "
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 44.5 79 L 45.5 81 L 44.5 79 Z "
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 47.5 108 L 150 108.5 L 47.5 109 L 47.5 108 Z "
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 151.5 109 L 155 111.5 L 152.5 110 L 151.5 109 Z "
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 44.5 119 L 45.5 121 L 44.5 119 Z "
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 48.5 121 L 149 121.5 L 48.5 122 L 48.5 121 Z "
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 195.5 122 L 196 123.5 L 191.5 127 L 191.5 126 L 195 123.5 L 195.5 122 Z "
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 176.5 134 L 179 135.5 L 177.5 136 L 176.5 134 Z "
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 184.5 134 L 189 134.5 L 184.5 135 L 184.5 134 Z "
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 190.5 134 L 195 134.5 L 190.5 135 L 190.5 134 Z "
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 167.5 145 L 166.5 147 L 167.5 145 Z "
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 211.5 145 L 212.5 147 L 211.5 145 Z "
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 47.5 148 L 150 148.5 L 47.5 149 L 47.5 148 Z "
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 153.5 150 L 154.5 152 L 153.5 150 Z "
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 153.5 159 L 152.5 161 L 153.5 159 Z "
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 160.5 160 L 161 165.5 L 160 165.5 L 160.5 160 Z "
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 218.5 160 L 219 162.5 L 218 162.5 L 218.5 160 Z "
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 48.5 161 L 150 161.5 L 48.5 162 L 48.5 161 Z "
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 136.5 168 L 139 168.5 L 136.5 169 L 136.5 168 Z "
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 239.5 168 L 243 168.5 L 239.5 169 L 239.5 168 Z "
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 134.5 169 L 133 171.5 L 132.5 173 L 132 171.5 L 134.5 169 Z "
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 141.5 169 L 152 178.5 L 150.5 178 L 141.5 169 Z "
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 237.5 169 L 234.5 173 L 237.5 169 Z "
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 244.5 169 L 246.5 172 L 244.5 169 Z "
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 14.5 170 L 15 172.5 L 14 172.5 L 14.5 170 Z "
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 160.5 170 L 161 173.5 L 160 173.5 L 160.5 170 Z "
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 218.5 171 L 219 173.5 L 218 173.5 L 218.5 171 Z "
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 247.5 173 L 248 175.5 L 247 175.5 L 247.5 173 Z "
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 232.5 174 L 230.5 177 L 232.5 174 Z "
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 2.5 176 L 3 178.5 L 2 178.5 L 2.5 176 Z "
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 218.5 176 L 219.5 178 L 218.5 176 Z "
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 228.5 177 L 227.5 179 L 228.5 177 Z "
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 246.5 177 L 247 178.5 L 238 186.5 L 246.5 177 Z "
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 159.5 178 L 158.5 180 L 159.5 178 Z "
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 133.5 179 L 139.5 186 L 133.5 179 Z "
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 153.5 179 L 157 181.5 L 155.5 181 L 153.5 179 Z "
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 142.5 187 L 146 189.5 L 144.5 189 L 142.5 187 Z "
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 236.5 187 L 235.5 189 L 236.5 187 Z "
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 233.5 189 L 232.5 191 L 233.5 189 Z "
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 20.5 190 L 21.5 192 L 20.5 190 Z "
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 151.5 192 L 153 195.5 L 152 195.5 L 151.5 192 Z "
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 22.5 193 L 23.5 195 L 22.5 193 Z "
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 24.5 196 L 27.5 200 L 24.5 196 Z "
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 10.5 198 L 11.5 200 L 10.5 198 Z "
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 151.5 198 L 152 201 L 135 200.5 L 151 200 L 151.5 198 Z "
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 228.5 200 L 249 200.5 L 228.5 201 L 228.5 200 Z "
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 12.5 201 L 13.5 203 L 12.5 201 Z "
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 251.5 201 Q 256 202 255 208.5 L 254 208.5 L 254 204.5 L 251.5 201 Z "
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 31.5 203 L 34.5 207 L 31.5 203 Z "
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 131.5 203 L 131 204.5 L 130.5 207 L 130 204.5 L 131.5 203 Z "
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 15.5 205 L 19.5 210 L 15.5 205 Z "
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 130.5 208 L 134 212.5 L 130 209.5 L 130.5 208 Z "
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 39.5 209 L 40.5 211 L 39.5 209 Z "
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 253.5 210 L 251.5 213 L 253.5 210 Z "
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 21.5 211 L 25.5 216 L 21.5 211 Z "
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 151.5 215 L 152 217.5 L 151 217.5 L 151.5 215 Z "
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 227.5 215 L 228 218.5 L 227 218.5 L 227.5 215 Z "
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 27.5 216 L 29.5 219 L 27.5 216 Z "
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 57.5 216 L 61 216.5 L 57.5 217 L 57.5 216 Z "
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 135.5 218 L 136.5 220 L 135.5 218 Z "
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 33.5 220 L 34.5 222 L 33.5 220 Z "
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 137.5 221 L 138 225.5 L 136 226.5 L 137.5 221 Z "
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 152.5 221 L 153 223.5 L 152 223.5 L 152.5 221 Z "
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 226.5 221 L 227 223.5 L 226 223.5 L 226.5 221 Z "
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 232.5 226 L 233.5 228 L 232.5 226 Z "
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 53.5 228 L 56 228.5 L 53.5 229 L 53.5 228 Z "
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 134.5 228 L 133.5 230 L 59 229.5 L 133.5 229 L 134.5 228 Z "
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 235.5 228 L 241 232.5 L 237.5 230 L 235.5 228 Z "
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 140.5 230 L 133.5 238 L 140.5 230 Z "
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 157.5 235 L 158.5 237 L 157.5 235 Z "
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 221.5 235 L 223 235.5 L 220.5 237 L 221.5 235 Z "
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 244.5 236 L 246.5 239 L 244.5 236 Z "
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 226.5 237 L 227.5 239 L 226.5 237 Z "
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 159.5 238 L 160.5 240 L 159.5 238 Z "
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 219.5 238 L 218.5 240 L 219.5 238 Z "
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 149.5 239 L 147.5 242 L 149.5 239 Z "
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 229.5 239 L 230.5 241 L 229.5 239 Z "
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 247.5 240 L 248 242.5 L 247 242.5 L 247.5 240 Z "
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 161.5 241 L 167.5 248 L 161.5 241 Z "
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 217.5 241 L 210.5 249 L 217.5 241 Z "
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 132.5 245 L 133.5 247 L 132.5 245 Z "
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 143.5 245 L 142.5 247 L 143.5 245 Z "
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 246.5 245 L 244.5 248 L 246.5 245 Z "
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 169.5 248 L 170.5 250 L 169.5 248 Z "
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 208.5 249 L 207.5 251 L 208.5 249 Z "
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 172.5 250 L 173.5 252 L 172.5 250 Z "
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 205.5 251 L 204.5 253 L 203 252.5 L 205.5 251 Z "
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 185.5 255 L 189 255.5 L 185.5 256 L 185.5 255 Z "
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(23,123,195)",
    stroke: "rgb(23,123,195)",
    strokeWidth: 1,
    opacity: 0.4666666666666667,
    d: "M 191.5 255 L 195 255.5 L 191.5 256 L 191.5 255 Z "
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(22,123,195)",
    stroke: "rgb(22,123,195)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 63.5 0 L 131.5 0 L 135.5 2 L 195 61.5 L 196 63.5 L 196 121.5 L 192.5 126 L 189.5 127 L 184 123.5 L 184 71 L 158.5 71 L 142.5 66 L 131 55.5 L 126 44.5 L 125 13 L 57.5 13 Q 38.9 16.9 28 28.5 Q 17.5 39 14 56.5 L 14 172.5 Q 18.3 195.7 34.5 207 L 46.5 214 L 57.5 217 L 131.5 217 L 137 220.5 Q 137.6 225.9 136 228 L 133.5 229 L 56.5 229 L 39.5 224 L 20 211 L 10 197.5 L 4 184.5 L 2 175.5 L 2 54.5 Q 7 30.5 22.5 17 Q 31.2 8.7 43.5 4 L 63.5 0 Z "
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(22,123,195)",
    stroke: "rgb(22,123,195)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 45.5 69 L 106.5 69 L 110 72.5 Q 110.8 78.3 107.5 80 L 105.5 81 L 46.5 81 L 43 79 L 42 73.5 L 45.5 69 Z "
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(22,123,195)",
    stroke: "rgb(22,123,195)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 109 L 150.5 109 L 155 112.5 Q 155.9 119.4 151.5 121 L 46.5 121 L 43 119 L 42 113.5 L 44.5 110 L 46.5 109 Z "
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(22,123,195)",
    stroke: "rgb(22,123,195)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 157.5 129 L 166.5 130 L 177.5 136 L 181.5 136 L 189.5 134 L 200.5 136 Q 208 129.5 221.5 129 L 225 131.5 L 226 136.5 L 222.5 141 Q 215 141.3 211 144 L 217 154.5 L 219 163.5 L 219 170.5 Q 216.8 171.8 218 176.5 L 221.5 181 Q 232.8 177.8 238.5 169 L 243.5 169 Q 248 170 247 176.5 L 237.5 187 L 226 193.5 L 228 201 L 250.5 201 L 254 204.5 Q 255.3 211.8 250.5 213 L 228.5 213 L 228 214.5 L 226 224 L 231.5 226 L 244 235.5 L 247 239.5 L 247 244.5 Q 246 249 239.5 248 L 234 243.5 Q 234.8 241.3 232.5 242 Q 228.5 237 221.5 235 L 209.5 249 L 200.5 254 L 189.5 256 L 174.5 252 L 161 240.5 L 157.5 235 Q 146.5 239 140.5 248 L 136.5 248 L 132 244.5 L 133 238.5 L 142.5 229 L 153 224 L 151 213 L 134.5 213 L 131 209.5 L 130 207.5 L 132 202 L 134.5 201 L 152 201 L 153 193.5 Q 140.6 188.4 133 178.5 L 132 173.5 L 135.5 169 L 140.5 169 Q 146.5 177.5 156.5 182 Q 162.3 179.8 161 170.5 L 160 166.5 L 162 155.5 L 168 144.5 L 154 138.5 L 153 134.5 L 155.5 130 L 157.5 129 Z "
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    fill: "rgb(22,123,195)",
    stroke: "rgb(22,123,195)",
    strokeWidth: 1,
    opacity: 1,
    d: "M 46.5 149 L 150.5 149 L 155 152.5 Q 155.9 159.4 151.5 161 L 46.5 161 L 43 158.5 L 42 154.5 L 44.5 150 L 46.5 149 Z "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBugreport);
export default __webpack_public_path__ + "static/media/bugreport.953a49afc0a3598435694b64670c8bab.svg";
export { ForwardRef as ReactComponent };